export default (audioService) => {
    'ngInject';
    return {
        restrict: 'A',
        scope: {
            words: '<',
            select: '<'
        },
        template: '<div><span ng-repeat="word in splitWords track by $index" ng-click="highlight($event)">{{word}}</span></div>',
        link: function ($scope, $element) {
            $scope.splitWords = $scope.words.split(' ');
            $scope.highlight = function (event) {
                if (!$scope.select) {

                  return;
                }
                audioService.play('buttonClick');
                angular.element(event.target).toggleClass('highlight__answer');
            };
        }
    };
};



// WEBPACK FOOTER //
// ./client/app/blocks/highliteWord/highliteWord.directive.js